<div class='acc-delivery-awards-tab-part'>

	@if(awardsInfo(); as info){
	<table class='pro-table pro-table-without-border pro-table-with-thin-rows w-100'>
		<tr>
			<th>Awards Info</th>
			<th>Value</th>
		</tr>
		<tr>
			<td>Total Accelerator Prize Budget</td>
			<td>{{info.totalBudget ? (info.totalBudget | currency:'USD': 'symbol': '1.0-0') : 'Not Provided'}}</td>
		</tr>
		<tr>
			<td>Money Awarded</td>
			<td>{{info.moneyAwarded | currency:'USD': 'symbol': '1.0-0'}}</td>
		</tr>
		<tr>
			<td>Money Remaining</td>
			<td>{{info.totalBudget ? ((info.totalBudget - info.moneyAwarded) | currency:'USD': 'symbol': '1.0-0') : '$0'}}</td>
		</tr>
	</table>
	}
</div>